import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { menuRoutes } from '../../../router/menu';

const SignDirectDebit: FC = () => {
    const navigate = useNavigate();
    const { hash } = useParams<{ hash: string }>();

    useEffect(() => {
        if (!hash) {
            navigate(menuRoutes.contract_public.error, { replace: true });
            return;
        }

        navigate(menuRoutes.contract_public.sign.split(':')[0] + hash, { replace: true });
    }, [hash, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <img
                src="/media/loading-name-lg.svg"
                alt="Redirigiendo a firma de documentos"
                className="w-25 h-25"
            />
        </div>
    );
};

export default SignDirectDebit;
